import { render, staticRenderFns } from "./mainImgDispaly.vue?vue&type=template&id=53dbb8ec&scoped=true"
import script from "./mainImgDispaly.vue?vue&type=script&lang=js"
export * from "./mainImgDispaly.vue?vue&type=script&lang=js"
import style0 from "./mainImgDispaly.vue?vue&type=style&index=0&id=53dbb8ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53dbb8ec",
  null
  
)

export default component.exports